import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../styles/fonts/Geist-Latin.woff2%22,%22weight%22:%22600%22,%22variable%22:%22--font-geist%22,%22display%22:%22swap%22}],%22variableName%22:%22geist%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'geist', 'geist Fallback'",
        fontWeight: 600,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
